// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  version: "1.1.5",
  //serverUrl: "https://localhost:3000/api",
  //serverUrl: "https://sipsignal.com/api",
  serverUrl: "https://efax.ubc.one/api",
  telnyxAPIToken: "KEY0196FE380CE0166710FE0354992AF5EC_GGXnDuz1aF3lTeVtA2p8ub",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
